import React from "react";
import "./LocFrameStyle.css";

const LocFrame = ({ source, title, roomID }) => {
  if (!source) {
    return <div>Loading...</div>;
  }

  return (
    <div className="loc-frame-wrapper">
      <iframe
        title={title}
        srcDoc={source}
        className="loc-frame"
        frameBorder="0"
      >
        {/* Fallback when no iframe can be displayed or if the browser does not support the tag. */}
        <p>Leider unterstützt dein Browser keine iframes.</p>
        <p>
          Bitte besuche die Webseite der Universität Regensburg für die
          Barriereinformationen.
        </p>
        <a
          href={`https://famos.app.uni-regensburg.de/hoersaele/index.php?raumid=${roomID}`}
          target={"_blank"}
          rel="noreferrer"
        >
          Link zur Seite von Raum {roomID}
        </a>
      </iframe>
    </div>
  );
};

export default LocFrame;
